"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.pedersen = exports.starknetKeccak = void 0;
var keccak_1 = require("ethereum-cryptography/keccak");
var minimalistic_assert_1 = __importDefault(require("minimalistic-assert"));
var constants_1 = require("../constants");
var ellipticalCurve_1 = require("../ellipticalCurve");
var encode_1 = require("./encode");
var number_1 = require("./number");
function keccakHex(value) {
    return (0, encode_1.addHexPrefix)((0, encode_1.buf2hex)((0, keccak_1.keccak256)((0, encode_1.utf8ToArray)(value))));
}
/**
 * Function to get the starknet keccak hash from a string
 *
 * [Reference](https://github.com/starkware-libs/cairo-lang/blob/master/src/starkware/starknet/public/abi.py#L17-L22)
 * @param value - string you want to get the starknetKeccak hash from
 * @returns starknet keccak hash as BigNumber
 */
function starknetKeccak(value) {
    return (0, number_1.toBN)(keccakHex(value)).and(constants_1.MASK_250);
}
exports.starknetKeccak = starknetKeccak;
var constantPoints = constants_1.CONSTANT_POINTS.map(function (coords) {
    return ellipticalCurve_1.ec.curve.point(coords[0], coords[1]);
});
function pedersen(input) {
    var point = constantPoints[0];
    for (var i = 0; i < input.length; i += 1) {
        var x = (0, number_1.toBN)(input[i]);
        (0, minimalistic_assert_1.default)(x.gte(constants_1.ZERO) && x.lt((0, number_1.toBN)((0, encode_1.addHexPrefix)(constants_1.FIELD_PRIME))), "Invalid input: " + input[i]);
        for (var j = 0; j < 252; j += 1) {
            var pt = constantPoints[2 + i * 252 + j];
            (0, minimalistic_assert_1.default)(!point.getX().eq(pt.getX()));
            if (x.and(constants_1.ONE).toNumber() !== 0) {
                point = point.add(pt);
            }
            x = x.shrn(1);
        }
    }
    return (0, encode_1.addHexPrefix)(point.getX().toString(16));
}
exports.pedersen = pedersen;
